import script from "./TwoFactorAuthView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoFactorAuthView.vue?vue&type=script&setup=true&lang=ts"

import "./TwoFactorAuthView.vue?vue&type=style&index=0&id=6c7bd99c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c7bd99c"]])

export default __exports__